import React, {useState} from 'react';

const Header = ({data}) => <thead>
<tr>
    {
        data.map((cell, i) => <th key={`dvh-${i}`}>{cell}</th>)
    }
</tr>
</thead>;
const Row = ({data, row}) => {
    return <tr>
        {
            data.map((cell, i) => <td key={`dvd-${row}-${i}`}>{cell}</td>)
        }
    </tr>;
};

const DataViewer = () => {
    const [grid, setGrid] = useState([]);
    window.setGrid = setGrid;
    const header = grid?.length > 0 && grid[0];
    const body = grid?.length > 0 && grid.slice(1);
    return <div className="data-viewer">
        {
            grid &&
            <table>
                {
                    header && <Header data={header}/>
                }
                <tbody>
                {
                    body && body.map((row, i) => {
                        return <Row data={row} row={i} key={`dv-${i}`} />
                    })
                }
                </tbody>
            </table>
        }
    </div>;
};

export default DataViewer;